"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSchema = void 0;
const zod_1 = require("zod");
const argumentValidation_1 = require("./argumentValidation");
exports.requestSchema = zod_1.z
    .array(zod_1.z.object({
    geom: zod_1.z.string(),
    dateStart: zod_1.z.string(),
    soilMoistureMAD: zod_1.z.number(),
}))
    .refine(argumentValidation_1.checkIfMadValueIsValid, {
    message: 'Soil MAD values must be within 0 and 100.',
    path: ['validation'],
});
//# sourceMappingURL=soilMADCreate.js.map